import React, { useState } from "react";

import InvoiceBalance from "./InvoiceBalance";
import PaymentHistory from "./PaymentHistory";
import Statement from "./Statement";

import { PageSubTitle } from "../../StyledComponents";
import { Div } from "../Styles";
import {
  // Container,
  // TabPanel,
  // Tabs,
  // New Styles
  NewContainer,
  NewTabPanel,
  NewTabs,
} from "./styles";
import SuperBill from "./superBill/index";

const Group = () => {
  const [opt, setOpt] = useState(1);
  const [invoOpt, setInvOpt] = useState(true);
  const [payOpt, setPayOpt] = useState(false);
  const [statementOpt, setStatementOpt] = useState(false);
  const [superBill, setSuperBill] = useState(false);

  const handleTabs = (e) => {
    setOpt(e);
    setInvOpt(e === 1);
    setPayOpt(e === 2);
    setStatementOpt(e === 3);
    setSuperBill(e === 4);
  };

  return (
    <>
      <NewContainer>
        <PageSubTitle padding="0px 0px 32px 0px">
          {opt === 1
            ? "Pending Invoices"
            : opt === 2
              ? "Payment History"
              : opt === 3
                ? "Statement"
                : "Superbill"}
        </PageSubTitle>
        <NewTabPanel>
          <NewTabs active={opt === 1} onClick={() => handleTabs(1)}>
            Pending Invoices
          </NewTabs>
          <NewTabs
            active={opt === 2}
            onClick={() => handleTabs(2)}
            id="bil_invLs-pyHis"
          >
            Payment History
          </NewTabs>
          <NewTabs active={opt === 3} onClick={() => handleTabs(3)}>
            Statement
          </NewTabs>
          <NewTabs active={opt === 4} onClick={() => handleTabs(4)}>
            Superbill
          </NewTabs>
        </NewTabPanel>
        <Div marginTop="25px">
          {opt === 1 ? (
            <InvoiceBalance />
          ) : opt === 2 ? (
            <PaymentHistory />
          ) : opt === 3 ? (
            <Statement />
          ) : (
            <SuperBill />
          )}
        </Div>
      </NewContainer>

      {/* Old UI Commented Out
      <Container>
        <PageSubTitle padding="20px">
          {opt === 1
            ? "Invoice List"
            : opt === 2
            ? "Payment History"
            : "Statement"}
        </PageSubTitle>
        <TabPanel>
          <Tabs active={invoOpt} onClick={() => handleTabs(1)}>
            Invoice Balance
          </Tabs>
          <Tabs
            active={payOpt}
            onClick={() => handleTabs(2)}
            id="bil_invLs-pyHis"
          >
            Payment History
          </Tabs>
          <Tabs active={statementOpt} onClick={() => handleTabs(3)}>
            Statement
          </Tabs>
          <Tabs active={superBill} onClick={() => handleTabs(4)}>
            Superbill
          </Tabs>
        </TabPanel>
        <Div marginTop="25px">
          {opt === 1 ? (
            <InvoiceBalance />
          ) : opt === 2 ? (
            <PaymentHistory />
          ) : opt === 3 ? (
            <Statement />
          ) : (
            <SuperBill />
          )}
        </Div>
      </Container>
      */}
    </>
  );
};

export default Group;
